import { useAppShellPush } from '@ids/appshell';
import { useAppContext } from '@ids/context/App';
import { trimTrailingSlash } from '@ids/router/helpers';

const Sections = {
    HERO: '#hero-block',
    OUR_PROJECTS: '#our-projects',
    PROJECT_SLIDER: '#project-slider',
    HOW_IT_WORKS: '#how-it-works',
    PRICE_TIERS: '#price-tiers',
    WHAT_YOU_GET: '#what-you-get',
    REVIEWS: '#reviews',
    FAQ: '#faq-block',
    PRESS: '#press',
};

type PushOptions = {
    withTrailingSlash?: boolean;
    replace?: boolean;
    preventScroll?: boolean;
};

const useIDSPush = () => {
    const push = useAppShellPush();
    const { idsPath } = useAppContext();
    const idsPush = (path: string, options?: PushOptions) =>
        push(
            `${trimTrailingSlash(idsPath)}${trimTrailingSlash(path)}${options?.withTrailingSlash ?? true ? '/' : ''}`,
            options?.replace ?? false,
            {},
            options?.preventScroll ?? true
        );

    idsPush.pushToSection = (section: keyof typeof Sections) =>
        push(`${trimTrailingSlash(idsPath)}${Sections[section]}`);

    return idsPush;
};

export default useIDSPush;
